import type { CustomerPrivacyDashboard } from '../../customerPrivacyApi'
import { formatDateTime } from '../../helpers/formatters'
import type { ShopLocale, ShopMessageKey } from '../../../i18n'
import { DataExportCard } from './DataExportCard'
import { PrivacyOverviewCard } from './PrivacyOverviewCard'

type TranslateFn = (key: ShopMessageKey, params?: Record<string, string | number>) => string

type PrivacyOverviewAndExportSectionProps = {
  dashboard: CustomerPrivacyDashboard
  locale: ShopLocale
  accountStatusLabel: string
  exportStateLabel: string
  privacyUpdatedAtValue: string
  readyToDownload: boolean
  exportRequesting: boolean
  exportDownloading: boolean
  onRequestExport: () => void
  onDownloadExport: () => void
  t: TranslateFn
}

export const PrivacyOverviewAndExportSection = ({
  dashboard,
  locale,
  accountStatusLabel,
  exportStateLabel,
  privacyUpdatedAtValue,
  readyToDownload,
  exportRequesting,
  exportDownloading,
  onRequestExport,
  onDownloadExport,
  t,
}: PrivacyOverviewAndExportSectionProps) => (
  <div className="grid gap-4 xl:grid-cols-[minmax(0,1.1fr)_minmax(0,0.9fr)]">
    <PrivacyOverviewCard
      title={t('customer.privacy.overview.title')}
      description={t('customer.privacy.overview.description')}
      accountStatusLabel={t('customer.privacy.overview.accountStatus')}
      accountStatusValue={accountStatusLabel}
      privacyUpdatedAtLabel={t('customer.privacy.overview.privacyUpdatedAt')}
      privacyUpdatedAtValue={privacyUpdatedAtValue}
      dataOwnerLabel={t('customer.privacy.overview.dataOwner')}
      dataOwnerValue={dashboard.account.username}
    />

    <DataExportCard
      title={t('customer.privacy.export.title')}
      description={t('customer.privacy.export.description')}
      stateLabel={t('customer.privacy.export.state')}
      stateValue={exportStateLabel}
      expiresAtLabel={t('customer.privacy.export.expiresAt')}
      expiresAtValue={formatDateTime(dashboard.exportState.expiresAt, locale, t('common.never'))}
      exportButtonLabel={t('customer.privacy.export.request')}
      exportButtonBusyLabel={t('customer.privacy.export.requesting')}
      downloadButtonLabel={t('customer.privacy.export.download')}
      downloadButtonBusyLabel={t('customer.privacy.export.downloading')}
      requesting={exportRequesting}
      downloading={exportDownloading}
      canDownload={readyToDownload}
      onRequestExport={onRequestExport}
      onDownload={onDownloadExport}
    />
  </div>
)
